import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { InspectionSection } from '../../shared/models/index';

@Component({
    selector: 'new-section',
    templateUrl: './new.component.html',
    standalone: false
})
export class NewSectionComponent implements OnInit {
  @Input() public processing;
  @Output() public toggleCreateSection: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();

  editForm: UntypedFormGroup;

  constructor() {}

  ngOnInit(): void {
    this.editForm = new UntypedFormGroup({
      name: new UntypedFormControl('', Validators.required),
      description: new UntypedFormControl('')
    });
  }

  public save(model: InspectionSection) {
    this.toggleCreateSection.emit(model);
  }

  public cancel() {
    this.toggleCancel.emit();
  }
}
